import { SHOP_PACK_PRICE } from './coins'

export type DonationTier = {
  id: string
  usdCents: number
  coins: number
}

/**
 * Thank-you coin packs. About half a Duel Links pack and half a
 * Master Duel card. Bigger packs step the rate down a little.
 * A shop pack stays `SHOP_PACK_PRICE` coins.
 */
export const DONATION_TIERS: readonly DonationTier[] = [
  { id: 'tip-3', usdCents: 300, coins: 210 },
  { id: 'tip-5', usdCents: 500, coins: 390 },
  { id: 'tip-10', usdCents: 1000, coins: 840 },
  { id: 'tip-20', usdCents: 2000, coins: 1800 },
]

export function donationTier(id: string): DonationTier | null {
  return DONATION_TIERS.find((tier) => tier.id === id) ?? null
}

/** Shop packs this coin grant buys at the current shop price. */
export function donationPacks(coins: number): number {
  if (!Number.isInteger(coins) || coins <= 0) return 0
  return Math.floor(coins / SHOP_PACK_PRICE)
}

/** Whole dollars stay `$3`. Anything else keeps two places. */
export function donationUsdLabel(usdCents: number): string {
  if (!Number.isInteger(usdCents) || usdCents < 0) return '$0'
  const dollars = usdCents / 100
  return Number.isInteger(dollars) ? `$${dollars}` : `$${dollars.toFixed(2)}`
}
